<app-base-dialog [title]="titleTemplate"
                 [saveBtnTextCodeOrTemplate]="saveButtonTemplate"
                 [cancelBtnTextCode]="'organizer.payment_service_provider.onboard.cancel'"
                 [saveDisabledCondition]="isContinueButtonDisabled"
                 [cancelDisabledCondition]="isLoading"
                 (save)="continue()"
                 (closeDialog)="cancel()"
                 [hideSaveBtn]="onboarding"
                 [hideCancelBtn]="onboarding"
>

<ng-template id="title-container" #titleTemplate>
    <div class="flex items-center gap-2">
      @if (paymentType === PaymentType.Stripe) {
        <i class="fa-brands fa-stripe" id="stripe-logo"></i>
      }
      <span id="onboarding-title">{{ 'organizer.payment_service_provider.onboard.title' | translate }}</span>
    </div>
  </ng-template>

  <ng-template #saveButtonTemplate>
    {{ 'organizer.payment_service_provider.onboard.continue' | translate }}
    @if (isLoading) {
      <mat-spinner color="accent" class="inline-block align-middle ml-1" diameter="15"></mat-spinner>
    }
  </ng-template>

@if (!onboarding) {
  

  <div class="grid gap-6">
    <p>{{ 'organizer.payment_service_provider.onboard.description' | translate }}
      @if (needsABankAccount) {
        {{ 'organizer.payment_service_provider.onboard.bank_account_required' | translate }}
      }
    </p>

    @if (needsABankAccount) {
      <app-add-new-account #addNewAccountComponent [onlyForm]="true"
                           (accountAdded)="onAccountAddedOrUpdated()" (accountUpdated)="onAccountAddedOrUpdated()"
                           (accountCreationFailed)="onAccountCreationError()"
                           (accountValidationFailed)="onAccountCreationError()"
                           [eventId]="eventId" [eventType]="eventType">
      </app-add-new-account>
    }
  </div>
  } 

  @if (isLoadingStripeData) {
    <div class="flex justify-center">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  }
  
  <div id="stripe-onboarding-container"></div>
</app-base-dialog>





